
const validate = (value, args) => {
  let result = false
  if (typeof value === 'number') {
    value = value.toString()
  } else if (typeof value !== 'string') {
    value = ''
  }
  if (!!value.length && /[0-9]/.test(value) && [10, 12].indexOf(value.length) !== -1) {
    const checkDigit = function (value, coefficients) {
      let n = 0
      for (const i in coefficients) {
        n += coefficients[i] * value[i]
      }
      return parseInt(n % 11 % 10)
    }
    switch (value.length) {
      case 10:
        const n10 = checkDigit(value, [2, 4, 10, 3, 5, 9, 4, 6, 8])
        if (n10 === parseInt(value[9])) {
          result = true
        }
        break
      case 12:
        const n11 = checkDigit(value, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8])
        const n12 = checkDigit(value, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8])
        if ((n11 === parseInt(value[10])) && (n12 === parseInt(value[11]))) {
          result = true
        }
        break
    }
  }
  return result
}

export default {
  validate
}
